// extracted by mini-css-extract-plugin
export default {"patrollersContainer":"Patrollers_patrollersContainer__-TJg5","content":"Patrollers_content__+ed6P","header":"Patrollers_header__aLjsi"};